var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSulfurIcDetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E2E8F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1025 8.215L11.1998 14.4L9.4695 7.9532L6.82732 6.19175L5.34375 9.7947L6.82732 18.32H17.8481L19.5436 12.338L17.8481 8.94695L15.9636 10.1086L15.1998 12.4L15.5168 9.54663V7.67532L12.9735 5.34399L10.1025 8.215Z",
    fill: "#818CA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9975 18.3199L16.7891 14.8899L16.0096 14.71L15.1765 18.3199H15.9975Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2198 18.3199L9.19044 13.5161L8.4082 13.6837L9.40167 18.3199H10.2198Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSulfurIcDetail);
export default __webpack_public_path__ + "static/media/sulfur-ic-detail.a06604673270c6fc880ef17c775c80f4.svg";
export { ForwardRef as ReactComponent };